module.exports = __webpack_public_path__ + "static/media/landing-1.da922c4a.jpg";